import { render, staticRenderFns } from "./programa-contrato.vue?vue&type=template&id=2d6dbaa6"
import script from "./programa-contrato.vue?vue&type=script&lang=js"
export * from "./programa-contrato.vue?vue&type=script&lang=js"
import style0 from "./programa-contrato.vue?vue&type=style&index=0&id=2d6dbaa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports